import styled from 'styled-components';
import { Collapse } from 'antd';
import { PageContainer, PrimaryButton, SpaceBetween } from '../../../../../styles/common.styles';
import { blue01, white } from '../../../../../styles/colors';

export const ProductsTabContainer = styled(PageContainer)`
    min-width: 1224px;
    padding: 24px 100px 60px 100px;
    position: relative;
`;

export const ProductsTabHeader = styled(SpaceBetween)`
    padding: 40px 0 28px 0;
    position: sticky;
    background-color: ${white};
    z-index: 1;
    top: 0;
`;

export const RecentUpdatesCollapse = styled(Collapse)`
    margin-bottom: 24px;
`;

export const ProductsTableHeader = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
`;

export const BannerWrapper = styled.div``;

export const NoCriteriaState = styled('div')`
    min-height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 18px;
    text-align: center;
    padding: 32px 24px;
`;

export const NoCriteriaText = styled('div')`
    text-align: center;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 120% */
    max-width: 540px;
    font-family: 'DIN Next W01 Medium';
    font-size: 20px;
    color: ${blue01};
`;

export const NoCriteriaButton = styled(PrimaryButton)`
    min-width: 110px;
    min-height: 34px;
    font-size: 14px;
    line-height: 18px;
    padding: 7px 14px;
`;
